import React, { useState, useEffect } from "react";
import profile from "../../Assets/Images/undraw_profile.svg";
import axiosHttp from "../../Config";
import Loader from "../../Components/Loader";
import { toast } from "react-toastify";

const RefundSettings = () => {
  const [formValues, setFormValues] = useState({
    mentorRefundPercent: "",
    menteeRefundPercent: "",
  });
  const [error, setError] = useState({
    mentorRefundPercent: "",
    menteeRefundPercent: "",
  });
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRefundPercentage();
  }, []);

  const fetchRefundPercentage = async () => {
    try {
      const getRefundPercentage = await axiosHttp.get("refund-settings");
      if (getRefundPercentage.status === 200) {
        let data = getRefundPercentage.data.data;
        setFormValues({
          mentorRefundPercent: data?.mentor_refund_percent,
          menteeRefundPercent: data?.mentee_refund_percent,
        });
        fetchFreeBookingCount();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFreeBookingCount = async () => {
    try {
      const getSettings = await axiosHttp.get("book-free-settings");
      if (getSettings.status === 200) {
        let data = getSettings.data.data;
        setCount(data.count);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setError({ ...error, [name]: "" });
    setFormValues({ ...formValues, [name]: value });
  };

  const profimeImg = localStorage.getItem("profileImg");

  const handleSubmit = () => {
    if (formValues.mentorRefundPercent === "") {
      setError({ ...error, name: "Mentor Refund Percent required" });
    } else if (formValues.menteeRefundPercent === "") {
      setError({ ...error, emailId: "Mentee Refund Percent required" });
    } else {
      submitHandler();
    }
  };

  const submitHandler = async () => {
    setLoading(true);
    try {
      const submitProfileData = await axiosHttp.post(`refund-settings`, {
        ...formValues,
      });
      if (submitProfileData.status === 201) {
        toast.success("Refund percentage updated successfully");
        fetchRefundPercentage();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleCountSubmit = async () => {
    setLoading(true);
    try {
      const submitCount = await axiosHttp.post(`book-free-settings`, {
        count: count,
      });
      if (submitCount.status === 201) {
        toast.success("Free bookings count updated successfully");
        fetchFreeBookingCount();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <div className="container-fluid top-container">
      <div className=" post mb-5">
        <div className="card  card-one-1 h-100">
          <div className="card-body">
            <h4 className="title mb-4">Refund Settings</h4>
            <div className="row">
              <div className="col-md-4"></div>
              <div className="col-md-4">
                <img
                  className="img-set rounded-circle admin-img"
                  src={profimeImg !== "null" ? profimeImg : profile}
                  alt="profile"
                />
              </div>
              <div className="col-md-4"></div>
            </div>

            <div className="row mt-5">
              <div className="col-md-4">
                <div className="form-group input-group mb-5">
                  <label className="has-float-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={formValues.mentorRefundPercent}
                      name="mentorRefundPercent"
                      onChange={handleChange}
                    />
                    <span>Mentor Refund Percentage</span>
                    {error.mentorRefundPercent && (
                      <p className="form-error">{error.mentorRefundPercent}</p>
                    )}
                  </label>
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group input-group mb-5">
                  <label className="has-float-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={formValues.menteeRefundPercent}
                      name="menteeRefundPercent"
                      onChange={handleChange}
                    />
                    <span>Mentee Refund Percentage</span>
                    {error.menteeRefundPercent && (
                      <p className="form-error">{error.menteeRefundPercent}</p>
                    )}
                  </label>
                </div>
              </div>
              <div className="col-md-4">
                <button
                  className="btn btn-primary modal-btn "
                  onClick={handleSubmit}
                  disabled={
                    formValues.mentorRefundPercent === "" ||
                    formValues.menteeRefundPercent === ""
                  }
                >
                  Save changes
                </button>
              </div>
            </div>
            <h4 className="title mb-4">Free Booking Settings</h4>
            <div className="row mt-5">
              <div className="col-md-4">
                <div className="form-group input-group mb-5">
                  <label className="has-float-label">
                    <input
                      className="form-control"
                      type="number"
                      placeholder=""
                      value={count}
                      name="count"
                      onChange={(e) => setCount(e.target.value)}
                    />
                    <span>Count</span>
                  </label>
                </div>
              </div>
              <div className="col-md-4">
                <button
                  className="btn btn-primary modal-btn "
                  onClick={handleCountSubmit}
                  disabled={
                    formValues.mentorRefundPercent === "" ||
                    formValues.menteeRefundPercent === ""
                  }
                >
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundSettings;
